export default __webpack_public_path__ + "static/media/large.d5682ac7.png";